export const DAYS_LEFT_TO_SHOW_ACTIVE_TARIFF_BLOCK = 7;
